import { computed, type Ref, ref, watch } from 'vue'

export function useSimplePagination<T>(data: Ref<T[] | undefined>, pageSize: Readonly<number> = 10) {
  const pagesNumber = ref(0)
  const pageData = computed(() =>
    [...(data.value ?? [])]?.splice((pagesNumber.value - 1) * pageSize, pageSize),
  )
  const pagesCount = computed(() => {
    if (data.value?.length) {
      return Math.ceil(data.value.length / pageSize)
    }
    return 0
  })

  watch([pagesCount, () => data.value?.length], () => {
    if (pagesCount.value === 0)
      pagesNumber.value = 1
    else
      pagesNumber.value = Math.min(Math.max(1, pagesNumber.value), pagesCount.value)
  })

  return { pagesNumber, pageData, pagesCount }
}
